import Login from "../views/Login.svelte";
import AsList from "../views/AsList.svelte";
import AsForm from "../views/AsForm.svelte";
import ProcessList from "../views/ProcessList.svelte";
import ProcessForm from "../views/ProcessForm.svelte";
import EndProcessList from "../views/EndProcessList.svelte";
import ProcessDetail from "../views/ProcessDetail.svelte";
import EndProcessDetail from "../views/EndProcessDetail.svelte";
import NotFound from "../views/NotFound.svelte";
import Temp from "../views/Temp.svelte";

export default {
    "/": Login,
    "/Login": Login,
    "/AsList": AsList,
    "/AsForm/:as_id": AsForm,
    "/ProcessList": ProcessList,
    "/ProcessForm/:as_id": ProcessForm,
    "/EndProcessList": EndProcessList,
    "/ProcessDetail/:as_id": ProcessDetail,
    "/EndProcessDetail/:as_id": EndProcessDetail,
    "/Temp": Temp,
    "*": NotFound,
};
